import React, { useState } from 'react';
import RPB_Logo from '../../images/RPB_Logo1.png';
import botom from '../../images/botom.png';
import twitter from '../../images/twitter.png';
import facebook from '../../images/facebook.png';
import { FaLinkedin, FaFacebookF, FaTwitter } from 'react-icons/fa';
import NavbarMobile from './NavbarMobile';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../hooks/LanguageContext';

const Header = () => {
    const { i18n } = useTranslation();
    const { currentLanguage, changeLanguage } = useLanguage();

    const handleLanguageChange = (event) => {
        const newLanguage = event.target.value;
        changeLanguage(newLanguage);
    };

    return (
        <nav className="navbar navbar-expand-lg custom-header p-1">
            <div className="container-fluid d-flex justify-content-between align-items-center">
                {/* Logo à gauche */}
                <a className="navbar-brand d-flex align-items-center" href="/">
                    <img
                        src={RPB_Logo}
                        alt="RPB Logo"
                        className="ms-lg-4 image-embleme"
                        style={{

                        }}
                    />
                </a>

                {/* Section droite desktop */}
                <div className="d-flex align-items-center gap-4 desktop-section" style={{
                    marginRight: "clamp(20px, 2vw, 30px)"
                }}>
                    <div className="option-langue-wrapper">
                        <select
                            className="option-langue"
                            value={currentLanguage}
                            onChange={handleLanguageChange}
                            style={{
                                border: "none",
                                backgroundImage: `url(${botom})`,
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "right 0px center",
                                backgroundSize: "clamp(25px, 2vw, 33px)",
                                paddingRight: "clamp(30px, 2.5vw, 40px)",
                                paddingLeft: "clamp(8px, 0.8vw, 10px)",
                                paddingTop: "clamp(4px, 0.4vw, 5px)",
                                paddingBottom: "clamp(4px, 0.4vw, 5px)",
                                fontSize: "clamp(16px, 1.4vw, 20px)",
                                marginRight: "clamp(30px, 3vw, 50px)"
                            }}>
                            <option value="fr">Français</option>
                            <option value="en">English</option>
                            <option value="zh">中文</option>
                        </select>
                    </div>

                    <div className="d-flex gap-4" style={{
                        gap: "clamp(20px, 2vw, 32px)"
                    }}>
                        <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                            <img src={facebook} style={{
                                width: "clamp(20px, 1.8vw, 26px)"
                            }} />
                        </a>
                        <a href="https://www.linkedin.com/showcase/benin-in-china/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="social-icon">
                            <FaLinkedin size={30} style={{
                                fontSize: "clamp(24px, 2vw, 30px)"
                            }} />
                        </a>
                        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                            <img src={twitter} style={{
                                width: "clamp(20px, 1.8vw, 26px)"
                            }} />
                        </a>
                    </div>
                </div>

                {/* Navbar mobile - MODIFIÉ */}
                <div className="mobile-section">
                    <NavbarMobile />
                </div>
            </div>

            <style type="text/css">
                {`
                    body{
                        background-color: #e6ecf4;
                    }

                    /********************************* Header************************* */

                    .custom-header {
                        background-color: #0a3764;
                        /* ANTI-ZOOM */
                        height: clamp(50px, 7vw, 94px);
                        // min-height: 50px;
                    }

                    .image-embleme {
                        height: clamp(50px, 6vw, 74px);
                        width: auto;
                    }

                    /* Section desktop - visible à partir de 1110px */
                    .desktop-section {
                        display: flex !important;
                    }

                    /* Section mobile - visible en dessous de 1110px */
                    .mobile-section {
                        display: none !important;
                    }

                    /* Style discret pour le select langue */
                    .option-langue {
                        border-radius: 5px;
                        border: 1px solid rgba(255, 255, 255, 0.3);
                        background-color: transparent; 
                        color: white;            
                        cursor: pointer;
                        appearance: none;
                        -webkit-appearance: none;
                        -moz-appearance: none;
                        outline: none;
                    }

                    /* Hover effect */
                    .option-langue:hover {
                        border-color: rgba(255, 255, 255, 0.6);
                    }

                    /* Focus effect */
                    .option-langue:focus {
                        border-color: rgba(255, 255, 255, 0.8);
                    }

                    /* Les options elles-mêmes */
                    .option-langue option {
                        color: black;
                        background-color: white;
                        font-size: clamp(12px, 1vw, 14px);
                        padding: clamp(6px, 0.6vw, 8px) clamp(10px, 1vw, 12px);
                    }

                    .option-langue-wrapper {
                        position: relative;
                        display: inline-block;
                    }

                    /* Flèche personnalisée */
                    .option-langue-wrapper::after {
                        position: absolute;
                        right: clamp(40px, 3.5vw, 58px);
                        top: 50%;
                        transform: translateY(-50%);
                        color: white;            
                        font-size: clamp(10px, 0.9vw, 12px);
                        pointer-events: none;
                        z-index: 2;
                    }

                    /* Icônes sociales */
                    .social-icon {
                        color: white;
                        font-size: clamp(18px, 1.7vw, 24px);
                        transition: color 0.3s ease;
                    }

                    .social-icon:hover {
                        color: #cccccc;
                    }

                    /* Bouton menu mobile */
                    .menu-btn {
                        background: none;
                        border: none;
                        cursor: pointer;
                    }

                    /* Menu mobile */
                    .mobile-menu {
                        background-color: #0a3764;
                        padding: 15px;
                        animation: slideDown 0.3s ease-in-out;
                    }

                    /* Animation */
                    @keyframes slideDown {
                        from { opacity: 0; transform: translateY(-10px); }
                        to { opacity: 1; transform: translateY(0); }
                    }

                    /* MEDIA QUERY PERSONNALISÉE POUR 1110px */
                    @media (max-width: 1109px) {
                        .desktop-section {
                            display: none !important;
                        }
                        
                        .mobile-section {
                            display: block !important;
                        }
                    }

                    @media (min-width: 1110px) {
                        .desktop-section {
                            display: flex !important;
                        }
                        
                        .mobile-section {
                            display: none !important;
                        }
                    }

                    /* Media queries pour garder la compatibilité mobile */
                    @media (max-width: 991px) {
                        .custom-header {
                            height: 85px !important;
                        }
                        .image-embleme {
                        height: clamp(60px, 6vw, 74px);
                        width: auto;
                    }
                    }
                `}
            </style>
        </nav>
    );
};

export default Header;